import { omit } from 'lodash';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
class AudioPluginService {
  createLoadingData(file, url, componentData) {
    const isCoverImageData = file.type.includes("image");
    if (isCoverImageData)
      return { componentData };
    const _a = componentData, { html, authorName, name, coverImage } = _a, rest = __objRest(_a, ["html", "authorName", "name", "coverImage"]);
    return {
      componentData: __spreadProps(__spreadValues({}, rest), {
        audio: { src: { id: url } },
        name: name || file.name.split(".")[0],
        authorName
      }),
      componentState: {
        tempData: true,
        loading: true
      }
    };
  }
  createPluginData(uploadedData, componentData) {
    var _b, _c, _d;
    const _a = componentData, rest = __objRest(_a, ["html", "tempData", "loading"]);
    const data = uploadedData.data;
    const isCoverImageData = data == null ? void 0 : data.file_name;
    const name = (_b = data == null ? void 0 : data.name) != null ? _b : componentData == null ? void 0 : componentData.name;
    const authorName = (_c = data == null ? void 0 : data.authorName) != null ? _c : componentData == null ? void 0 : componentData.authorName;
    const audio = (_d = data == null ? void 0 : data.audio) != null ? _d : componentData == null ? void 0 : componentData.audio;
    let coverImage;
    if (isCoverImageData) {
      coverImage = { src: { id: data.file_name } };
    }
    return __spreadProps(__spreadValues({}, rest), {
      audio,
      name,
      authorName,
      coverImage
    });
  }
  createErrorData(error, componentData) {
    return __spreadProps(__spreadValues({}, omit(componentData, ["tempData"])), {
      error
    });
  }
}

export { AudioPluginService };
//# sourceMappingURL=audioPluginService.js.map
